import React from "react";
import { useTranslation } from "react-i18next";
import { ShieldAlert } from "lucide-react";

export default function TopBar() {
  const { t } = useTranslation();
  return (
    <div className="bg-gradient-to-r from-[#0e1a36] via-[#15244a] to-[#0e1a36] border-b border-amber-500/10">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 text-[11px] sm:text-xs text-amber-100/90">
        <ShieldAlert className="w-3.5 h-3.5 text-amber-400 shrink-0" />
        <span className="text-center">
          <span className="text-amber-300 font-semibold">{t("topBar.18plus")}</span> · {t("topBar.disclaimer")}
        </span>
      </div>
    </div>
  );
}
